import { html, TemplateElement } from '@webtides/element-js';
import SpecChipEvents from './SpecChipEvents';
import styles from './_spec-chip.css';

export default class SpecChip extends TemplateElement {
    constructor(options) {
        super({ shadowRender: false, styles: [styles], ...options });
    }

    properties() {
        return {
            label: 'label',
            key: 'key',
            value: 'value',
            index: '-1',
        };
    }

    events() {
        return {
            this: {
                click: () => this.dispatch(SpecChipEvents.REMOVE_INDEX, { key: this.key, index: this.index }, true),
            },
        };
    }

    template() {
        return html`
            <div class="group chip cursor-pointer inline-flex flex-row flex-shrink-0 items-center ">
                <div class="chip-label inline-block flex-shrink-0">
                    ${this.label}
                    ${this.renderValue
                        ? html`
                              ${this.value}
                          `
                        : ''}
                </div>

                <div class="icon flex items-center justify-center">
                    <svg-icon name="close"></svg-icon>
                </div>
            </div>
        `;
    }
}
